import React from "react";
import pagos from "../../assets/image/stella/pagos.png";

function Section3() {
    return (
        <>
            <section className="pt-10 max-md:px-5 bg-[#dc4600]">
                <div className="container"><h2
                    className="text-2xl md:text-[25px] font-bold text-center">PREGUNTAS DE RENOVACIONES Stella TV
                    OFICIAL</h2>
                    <div className="mt-5 border border-white text-white">
                        <details>
                            <summary className="py-[15px] px-5 cursor-pointer font-bold border-b">Cómo renovar una
                                cuenta de Stella TV oficial?
                            </summary>
                            <div className="py-[15px] px-5 text-[17px] leading-relaxed border-b">Para renovar una
                                cuenta, simplemente realiza el pago del plan deseado y envía tu cuenta al chat de
                                WhatsApp para que se procese la renovación. Recuerda que la renovación solo será posible
                                si la cuenta fue comprada en este sitio web y no a través de otros vendedores.
                            </div>
                        </details>
                        <details>
                            <summary className="py-[15px] px-5 cursor-pointer font-bold border-b">Las renovaciones de
                                Stella TV son automáticas?
                            </summary>
                            <div className="py-[15px] px-5 text-[17px] leading-relaxed border-b">No, las renovaciones se
                                procesan de forma manual. Siempre que desees renovar, contáctanos para recibir
                                instrucciones sobre cómo realizar el pago y actualizar tu plan de StellaTV.
                            </div>
                        </details>
                        <details>
                            <summary className="py-[15px] px-5 cursor-pointer font-bold border-b">Los precios para
                                renovar son los mismos?
                            </summary>
                            <div className="py-[15px] px-5 text-[17px] leading-relaxed border-b">Los precios de
                                renovación se mantienen sin cambios, sin necesidad de pagar más. Aprovecha nuestras
                                promociones de fin de año y aniversario, en las que añadimos meses adicionales a los
                                planes actuales.
                            </div>
                        </details>
                        <details>
                            <summary className="py-[15px] px-5 cursor-pointer font-bold border-b">Qué métodos de pago
                                son aceptados?
                            </summary>
                            <div className="py-[15px] px-5 text-[17px] leading-relaxed border-b">Aceptamos todos los
                                métodos de pagos online para los diferentes países, asimismo en algunos tenemos opciones
                                de pago en efectivo. Puede pagar de manera rápida y segura al 100% desde México,
                                Colombia, Ecuador, Perú, Argentina, España, Estados Unidos, Chile, Bolivia, Venezuela,
                                Brasil, El Salvador, Costa Rica, Puerto Rico, República Dominicana, Guatemala, Uruguay,
                                Paraguay, Honduras, Panamá, etc.
                            </div>
                        </details>
                        <details>
                            <summary className="py-[15px] px-5 cursor-pointer font-bold border-b">Mi cuenta la compre a
                                otro vendedor, pueden renovarla?
                            </summary>
                            <div className="py-[15px] px-5 text-[17px] leading-relaxed border-b">Si adquiriste tu cuenta
                                en otro lugar, no podremos renovarla. Sin embargo, podemos ofrecerte una cuenta nueva,
                                la cual podrás renovar con nosotros sin ningún inconveniente en el futuro.
                            </div>
                        </details>
                    </div>
                </div>
            </section>

            <footer className="bg-[#dc4600] pt-5 max-md:px-5 pb-[200px]">
                <div className="container text-[12px] leading-[1.5em] font-light text-white">DMCA: La web
                    https://www.stellatv.net viene a ser un distribuidor externo y autorizado de los servicios digitales
                    de material de entretención que distribuye de modo total Stella, quienes cumplen con toda norma
                    legal según el país de origen desde el cual distribuyen el servicio. https://www.stellatv.net no
                    almacena ni sube en su sitio o servidor, cualquier archivo de vídeo, película, archivo multimedia de
                    ningún tipo o cualquier otro material que este protegido por la ley de derechos de autor.
                    https://www.stellatv.net no poseen ni comercializan decodificadores de TV satelital de ningún tipo.
                    https://www.stellatv.net cumple solo en calidad de distribuidor de servicio para el alcance de
                    sudamerica. https://www.stellatv.net está de acuerdo con 17 USC § 512 y la Digital Millennium
                    Copyright Act (“DMCA”). Es nuestra política DERIVAR a Stella TV cualquier notificación de infracción
                    para que ellos tomen las acciones correspondientes bajo la Digital Millennium Copyright Act (“DMCA”)
                    y otras leyes de propiedad intelectual aplicables. https://www.stellatv.net no es parte de STELLATV.
                </div>
                <img alt="" loading="lazy" width="505" height="70" decoding="async" data-nimg="1"
                     className="mx-auto mt-20" src={pagos}
                     /></footer>
        </>
    );
}

export default Section3;
